import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ErrorActionType, ErrorsService } from 'common';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LegacyMobileAppGuard implements CanActivate {
  constructor(private errorsService: ErrorsService) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const isFlutterWebView: boolean = (window as any)?.flutter_inappwebview;
    if (isFlutterWebView){
      const description: string = 'Your current version of the app is no longer supported. To continue using the app securely, please update to the latest version. Access will be restricted until the update is installed.'
      const title: string = 'Update required';
      const actionType: ErrorActionType = ErrorActionType.UpdateApp
      this.errorsService.showCustomErrorPage(description, title, actionType);
      return false;
    }
    return true;
  }
}
